import React from "react";
import DataTable from "../reusable/DataTable";
import { AccessControl } from "@careinfo/permission-required";
import TableActionButton from "../reusable/TableActionButton";
import SwitchButton from "../reusable/SwitchButton";
import NACell from "../reusable/DataTable/NACell";
import APIS from "../../constant/Endpoint";
import { useNavigate } from "react-router-dom";
import usePermission from "../../customHooks/usePermission";

const Hublist = () => {
  const navigate = useNavigate();
  const canUpdateSetting = usePermission({
    allowedPermissions: ["can_update_setting"],
  });
  const handleRowClick = (row: any) => {
    if (canUpdateSetting.isAllowed === false) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: NACell,
    },
  ];
  return (
    <DataTable
      url={APIS.HUB}
      queryKey={"hub"}
      columns={defaultColumns}
      addNewPagePath={"create"}
      tableName={"hub"}
      onRowClick={handleRowClick}
    />
  );
};

export default Hublist;
